export interface CorbisCreateCartBody {
    contexte: string;
    ihmAppelante: string;
    localisation: {
        adresse: {
            _type: string;
            codeINSEE: string;
            codePostal: string;
            codeRivoli: string;
            commune: string;
            hexaCleInterne: string;
            idAdresseByTel: string;
            voie: string;
            numero: string;
            imb: string;
        };
    };
    typeActeur: string;
    typeClient: string;
}

export const CorbisCreateCartBodyPY: CorbisCreateCartBody = {
    contexte: 'ACQUISITION',
    ihmAppelante: 'ECOMMERCE',
    localisation: {
        adresse: {
            _type: 'AdresseHorizontale',
            codeINSEE: '75120',
            codePostal: '75020',
            codeRivoli: '7899',
            commune: 'PARIS',
            hexaCleInterne: '7512022EXS',
            idAdresseByTel: '75120PY0RY00011',
            voie: 'RUE DE LA PY',
            numero: '25',
            imb: 'ID-75120000005K',
        },
    },
    typeActeur: 'CLIENT',
    typeClient: 'GP_PRO',
};
